<script lang="ts">
  import { ShoppingCart, FileText, Loader2 } from "@lucide/svelte";
  import { __ } from '@wordpress/i18n';

  type MessageType = "success" | "error" | "info";

  type Props = {
    isComplete: boolean;
    isAdding: boolean;
    message?: string;
    messageType?: MessageType;
    onAddToCart: () => void;
    onRequestQuote: () => void;
  };

  let { isComplete, isAdding, message, messageType = "info", onAddToCart, onRequestQuote }: Props = $props();

  // Dynamic alert class based on message type
  const alertClass = $derived.by(() => {
    const classes = ["wpc-alert"];
    if (messageType === "error") classes.push("wpc-alert--error");
    else if (messageType === "success") classes.push("wpc-alert--success");
    else classes.push("wpc-alert--info");
    return classes.join(" ");
  });
</script>

<div class="wpc-actions">
  {#if message}
    <div class={alertClass}>
      {message}
    </div>
  {/if}

  <div class="wpc-btn-group">
    <button type="button" class="button wpc-btn" disabled={!isComplete || isAdding} onclick={onAddToCart}>
      {#if isAdding}
        {__('Laden...', 'wpc')}
      {:else}
        {__('Toevoegen aan winkelwagen', 'wpc')}
      {/if}
    </button>

    <button type="button" class="button wpc-btn wpc-btn--outline" disabled={!isComplete || isAdding} onclick={onRequestQuote}> {__('Offerte aanvragen', 'wpc')} </button>
  </div>

  {#if !isComplete}
    <p class="wpc-text--muted wpc-text--left wpc-incomplete-msg">
      {__('Voltooi alle stappen om toe te voegen aan winkelwagen', 'wpc')}
    </p>
  {/if}
</div>
